module.exports = __webpack_public_path__ + "assets/hide.bf62c087.svg";